<template>
    <PopupRouterViewDetail label="Part Mapping Subcontract Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Part Mapping Subcontract" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Finish Good Part" id="fieldset-part" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  @change="updateData" :isUpdatable ="true"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part Subcont" id="fieldset-part-subcont" size="sm" :model.sync="model.partSubcontId" :isRequired="true" :state="validateState('partSubcontId')" :errorMessage="getErrorMessage(errorMessage.partSubcontId, 'partSubcontId')"   :selected="model.partSubcont != null ? model.partSubcont.partNumber : ''" @input="getParts" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedPartSubcont" />
				</b-col>

            </b-row>
        </b-card>

        <b-card header="Vendor Subcont Information" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor-subcontract" size="sm" :model.sync="model.vendorSubcontractId"   :selected="model.vendorSubcontract != null ? model.vendorSubcontract.code : ''" @input="getVendors" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendorSubcontract" />
						<app-label label-cols-lg="12" size="sm" label="Name" :model="(model.vendorSubcontract != null) ? model.vendorSubcontract.name : null"  />
					</b-col>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" label="Office Address" :model="(model.vendorSubcontract != null) ? model.vendorSubcontract.officeAddress : null"  />
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartMappingSubcontract from '@/models/PartMappingSubcontract/PartMappingSubcontract';
import PartMappingSubcontractList from '@/models/PartMappingSubcontract/PartMappingSubcontractList';
import PartMappingSubcontractFilter from '@/filters/PartMappingSubcontract/PartMappingSubcontractFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppLabel from '@/components/AppLabel';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextarea,
		AppLabel,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			partId: {required},
			partSubcontId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				partId: { required : "Finish Good Part is Required."},
				partSubcontId: { required : "Part Subcont is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterPartMappingSubcontract : null,
			currentPartMappingSubcontractPage : 1,
			partMappingSubcontractPageSize: 10,
			sortByPartMappingSubcontract: '',
			sortDescPartMappingSubcontract: '',
			parts: [],
			parts: [],
			isPartComboLoading: false,
			vendors: [],
			vendorSubcontracts: [],
			isVendorSubcontractComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartComboLoading: false,
			isVendorComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getPartMappingSubcontract : async function(id) {
			this.isBusy = true;
			PartMappingSubcontract.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.vendorSubcontractId != null) {
					promises.push(
						this.getVendor(this.model.vendorSubcontractId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartMappingSubcontract = true;
			this.filterPartMappingSubcontract.id = this.modelId;
			PartMappingSubcontract.downloadDataDetail(this, this.filterPartMappingSubcontract).then(result => {
				this.isDownloadPartMappingSubcontract = false;
			}).catch(error => { this.isDownloadPartMappingSubcontract = false; })
		},
		getPartMappingSubcontracts : async function(input) {
			let filter = new PartMappingSubcontractFilter();
			if (input != undefined) {
				filter.Part = input;
			}
			this.isPartMappingSubcontractComboLoading = true;
			PartMappingSubcontract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partMappingSubcontracts = result.data
				}
				this.isPartMappingSubcontractComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedPartSubcontExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.partSubcontId = null;
				this.model.partSubcont = null;
				this.isBusy = true;
				PartMappingSubcontract.resetDocument(this, this.model.id).then(result => {
					this.getPartMappingSubcontract(this.model.id).then(result => {
						this.gets();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.partSubcontId = item.id;
				this.model.partSubcont = item;

				this.isBusy = true;
				PartMappingSubcontract.copyFromDocument(this, 'part', item.id, this.model.id).then(result => {
					this.getPartMappingSubcontract(this.model.id).then(result => {
						this.gets();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedPartSubcont(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.partSubcontId == itemId) return;
			}

			if(this.s != null && this.s.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Part Mapping Subcontract akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedPartSubcontExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedPartSubcontExecuted(item);
			}
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendorSubcontract(item) {
			if(item == undefined || item == null) {
				this.model.vendorSubcontractId = null;
				this.model.vendorSubcontract = null;
			} else {
				this.model.vendorSubcontractId = item.id;
				this.model.vendorSubcontract = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendor : async function(id) {
			Vendor.getData(this, id).then(result => {
				this.model.vendorSubcontract = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partMappingSubcontractInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PartMappingSubcontract.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'partmappingsubcontractindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						PartMappingSubcontract.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'partmappingsubcontractindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartMappingSubcontract.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getPartMappingSubcontract(id);
					});
				}
			});
		},
		onHidden() {
			this.getPartMappingSubcontracts();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterPartMappingSubcontract = new PartMappingSubcontractFilter();
		//this.getParts();
		//this.getVendors();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPartMappingSubcontract(id);
			} else {
				this.modelId = id;
				this.getPartMappingSubcontract(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
